module.exports = __webpack_public_path__ + "img/contact.de45f1f2.png";